module.exports = __webpack_public_path__ + "img/advantage_2.82502642.png";